import { createAsyncThunk } from "@reduxjs/toolkit";
import UserServices from "../../../api/services/user";

export const getUserInfoByIdUnauthorized = createAsyncThunk(
  "coupon/get-user-info-unauthorized",
  async (requestData) => {
    return await UserServices.getUserInfoByIdUnauthorized(requestData);
  }
);
